module.exports = __webpack_public_path__ + "static/media/AvatarOther.8235b4b6.svg";